import React, { Component, Children } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createClient } from 'mage-core'
import { actions as experimentationActions, selectors as experimentationSelectors } from 'mage-experimentation'

export class FeaturesProvider extends Component {
  componentDidMount () {
    const { getFeatures, client, desired, options } = this.props
    getFeatures(client, desired, options)
  }

  render () {
    const { loadingComponent, errorComponent, loading, error, children } = this.props
    const LoadingComponent = loadingComponent
    const ErrorComponent = errorComponent

    if (loading) return <LoadingComponent />
    if (error) return <ErrorComponent />

    return Children.only(children)
  }
}

FeaturesProvider.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.object,
  desired: PropTypes.object.isRequired,
  getFeatures: PropTypes.func.isRequired,
  loadingComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element
  ]),
  errorComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element
  ]),
  client: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ]),
  children: PropTypes.node,
  options: PropTypes.object
}

FeaturesProvider.defaultProps = {
  loadingComponent: () => null,
  errorComponent: () => null,
  options: {}
}

export default connect(
  (state) => ({
    loading: experimentationSelectors.isFeaturesLoading(state),
    error: experimentationSelectors.getFeaturesError(state),
    features: experimentationSelectors.getFeatures(state),
    client: createClient(state)
  }),
  { getFeatures: experimentationActions.features.fetch }
)(FeaturesProvider)
